import * as React from 'react';
import styled from 'styled-components';

import { AllScreenInfoWindow } from '../AllScreenInfoWindow/AllScreenInfoWindow';
import { ReactNode } from 'react';
import PATHS, { IOSAppPath } from '../../constants/paths';
import { BlueLink } from '../MPLink';
import SvgIcon from '../SvgIcon';
import { GumroadProduct } from 'src/components/MembershipSettings';
import { SubscribeButton } from '../MembershipSettings/SubscribeButton';
import { FormattedMessage, useIntl } from 'react-intl';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2``;
const SubTitle = styled.span`
  margin-bottom: 10px;
  line-height: 1.5;
`;

const FeatureBlockContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const FeatureBlockTextsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
`;

const FeatureTitle = styled.span`
  font-weight: ${p => p.theme.font.weight.medium};
  font-size: ${p => p.theme.font.size.regular};
  margin-top: 9px;
`;

const FeatureDescr = styled.span`
  margin: 10px 0;
  line-height: 1.5;
`;

const SubscribeButtonsContainer = styled.div`
  a {
    margin: 5px 0;
  }
`;

interface FeatureBlockProps {
  readonly img: any;
  readonly title: string;
  readonly descriptionNode: ReactNode;
}

const ImgContainer = styled.div`
  width: 50px;
  height: 50px;
`;

const FeatureBlock = (props: FeatureBlockProps) => {
  return (
    <FeatureBlockContainer>
      <ImgContainer>{props.img}</ImgContainer>
      <FeatureBlockTextsContainer>
        <FeatureTitle>{props.title}</FeatureTitle>
        {props.descriptionNode}
      </FeatureBlockTextsContainer>
    </FeatureBlockContainer>
  );
};

const SmallLink = styled(BlueLink)`
  font-size: ${p => p.theme.font.size.small};
`;

const LearnMoreLink = styled(SmallLink)`
  align-self: center;
  padding-top: 10px;
`;

const FeatureIcon = styled(SvgIcon)`
  width: 50px;
  height: 50px;
`;

export const SubscriptionsPromo = (props: any) => {
  const messageBase = 'components.SubscriptionsPromo';
  const intl = useIntl();

  return (
    <Container>
      <Title>
        <FormattedMessage id={`${messageBase}.title`} />
      </Title>
      <SubTitle>
        <FormattedMessage id={`${messageBase}.subtitle`} />
      </SubTitle>
      <FeatureBlock
        img={<FeatureIcon iconWidth={50} iconHeight={50} iconName="ic-insights" />}
        title={intl.formatMessage({
          id: `${messageBase}.text_insights`,
        })}
        descriptionNode={
          <FeatureDescr>
            <FormattedMessage id={`${messageBase}.text_insights.description`} />
            <SmallLink to={PATHS.FAQ.LANGUAGE_SUPPORT} isExternal={true}>
              <FormattedMessage id={`${messageBase}.text_insights.languages`} />
            </SmallLink>
          </FeatureDescr>
        }
      />
      <FeatureBlock
        img={<FeatureIcon iconWidth={50} iconHeight={50} iconName="ic-cloud" />}
        title={intl.formatMessage({
          id: `${messageBase}.sync.title`,
        })}
        descriptionNode={
          <FeatureDescr>
            <FormattedMessage id={`${messageBase}.sync.description`} />
            <br />
            <SmallLink to={IOSAppPath} isExternal={true}>
              <FormattedMessage id={`${messageBase}.sync.get_app`} />
            </SmallLink>
          </FeatureDescr>
        }
      />
      <SubscribeButtonsContainer>
        <SubscribeButton
          product={GumroadProduct.yearly}
          color="blue"
          outline={false}
          messageId={intl.formatMessage({
            id: `${messageBase}.subscribe.annually`,
          })}
        />
        <SubscribeButton
          product={GumroadProduct.monthly}
          color="blue"
          messageId={intl.formatMessage({
            id: `${messageBase}.subscribe.monthly`,
          })}
        />
      </SubscribeButtonsContainer>
      <LearnMoreLink to={PATHS.FAQ.ROOT} isExternal={true}>
        <FormattedMessage id={`${messageBase}.learn_more`} />
      </LearnMoreLink>
    </Container>
  );
};

export default SubscriptionsPromo;

export const AllScreenSubscriptionsPromo = () => {
  return (
    <AllScreenInfoWindow>
      <SubscriptionsPromo />
    </AllScreenInfoWindow>
  );
};



// WEBPACK FOOTER //
// ./src/components/SubscriptionsPromo/index.tsx